import store from '../Redux/Store/store';
import checkAnimationRepeatedName from './checkAnimationRepeatedName';
import { AddAnimationPayloadInterface } from '../Redux/Actions/Animator/animation.list.action';
import { ActionAnimationList } from '../Redux/Reducers/Animator/animation.list.reducer';

const preventAnimationNameDuplicate = (animation: AddAnimationPayloadInterface, animationList?: ActionAnimationList) => {
    let animationData = animationList ? animationList : store.getState().AnimationList;
    let animationCopy = animation;
    let iterations = 0;
    let initialName = animationCopy.name;
    while (checkAnimationRepeatedName(animationCopy, animationData.animations)) {
        iterations++;
        animationCopy.name = `${initialName}${iterations}`;
    }
    return (animationCopy.name);
}

export default preventAnimationNameDuplicate;